import { CloseOutlineIcon, type Color } from '@carboncopyco/icons';
import classNames from 'classnames';
import type React from 'react';
import { type BgColors, ColorHex } from '../../constants';

export type NotificationRawSnackbarProps = {
  hideClose?: boolean;
  closeIconColor?: Color;
  backgroundColor?: BgColors;
};

export const NotificationRawSnackbar: React.FC<
  React.PropsWithChildren<NotificationRawSnackbarProps>
> = ({
  hideClose,
  closeIconColor = ColorHex.natural600,
  backgroundColor = 'bg-ds-accent3-100',
  children,
}) => {
  return (
    <div
      className={classNames(
        'flex items-start justify-between py-2.5 px-4 min-h-10 text-ds-natural-600',
        backgroundColor
      )}
    >
      {children}
      {!hideClose && (
        <div>
          <CloseOutlineIcon
            color={closeIconColor}
            size={16}
          />
        </div>
      )}
    </div>
  );
};
